import type { MouseEvent } from "react";

export default function Footer() {
  const go = (href: string) => (e: MouseEvent) => {
    e.preventDefault();
    const el = document.querySelector(href);
    el?.scrollIntoView({ behavior: "smooth" });
  };

  const columns = [
    {
      title: "爆笑栏目",
      links: [
        { label: "今日爆梗", href: "#feed" },
        { label: "深度吐槽特辑", href: "#featured" },
        { label: "弹幕金句", href: "#quotes" },
        { label: "表情包收割机", href: "#memes" },
      ],
    },
    {
      title: "吃瓜指南",
      links: [
        { label: "按口味吃瓜", href: "#categories" },
        { label: "常见问题", href: "#faq" },
        { label: "吐槽投稿站", href: "#contribute" },
        { label: "关于我们", href: "#about" },
      ],
    },
  ];

  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1.1fr]">
          <div>
            <a href="#top" onClick={go("#top")} className="flex items-center gap-2 whitespace-nowrap">
              <span className="grid h-9 w-9 place-items-center rounded-2xl bg-primary-500 text-background-50">
                <i className="ri-emotion-laugh-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">
                55<span className="text-primary-600">吃瓜</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              全网最离谱的沙雕剧情与表情包收割机，收集笑中带泪的瓜田故事。没有冷场，只有热梗，边看边笑到肚子疼。
            </p>
            <div className="mt-5 flex items-center gap-2.5">
              {[
                { icon: "ri-wechat-line", label: "微信公众号" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-tiktok-line", label: "抖音" },
                { icon: "ri-mail-line", label: "邮件" },
              ].map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  aria-label={s.label}
                  className="grid h-9 w-9 cursor-pointer place-items-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${s.icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="font-heading text-base text-foreground-950">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.href + l.label}>
                    <a
                      href={l.href}
                      onClick={go(l.href)}
                      className="flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      <i className="ri-arrow-right-s-line"></i>
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div>
            <h3 className="font-heading text-base text-foreground-950">想找我们</h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              投稿吐槽、内容合作或意见反馈，欢迎随时写信给我们，编辑部看到就会尽快回复。
            </p>
            <a
              href="mailto:hello@55chigua.com"
              className="mt-4 inline-flex items-center gap-2 rounded-full bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-foreground-950 hover:text-background-50"
            >
              <i className="ri-mail-send-line"></i>
              hello@55chigua.com
            </a>
            <p className="mt-4 flex items-center gap-1.5 text-xs text-foreground-500">
              <i className="ri-time-line"></i> 编辑部在线吃瓜：每日 09:00 - 22:00
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} 55吃瓜 · 爆笑沙雕吐槽合集，笑中带泪的表情包收割机</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-line text-primary-500"></i>
            内容仅供娱乐，投稿均为演绎/脱敏处理，请勿引战
          </p>
        </div>
      </div>
    </footer>
  );
}